import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import RoundedAvatar from './rounded-avatar';

const gap = 24;
const avatarWidth = 40;
const minOverlap = 5;
const maxAvatarsSupported = 50;
const overlap = n => minOverlap + n * (avatarWidth - 2 * minOverlap) / maxAvatarsSupported;
const Container = styled.div`
  position: absolute;
  width: ${props => `${props.count * (avatarWidth - overlap(props.count))}px`};
  top: 17px;
  left: ${props => `${-1 * (props.count * (avatarWidth - overlap(props.count)) + gap)}px`};
  display: flex;
  flex-direction: row-reverse;

  & > img {
    flex-shrink: 0;
    margin-left: ${props => `${-1 * overlap(props.count)}px`};
  }
`;

export default function StackedAvatars({ contributors }) {
  return (
    <Container count={contributors.length}>
      {contributors.map(c => <RoundedAvatar {...c} key={c.name} />)}
    </Container>
  );
}

StackedAvatars.propTypes = {
  contributors: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    profilePictureUrl: PropTypes.string,
  })).isRequired,
};
